<script setup lang="ts">
import { ref } from 'vue';
import { PhxUspTabs, PhxTooltip } from '@phx-styleguides/jlc';

type UspBullet = {
  text: string;
  tooltip?: string | null;
};

type UspTab = {
  id: string;
  label: string;
  media: string;
  title?: string | null;
  bullets: UspBullet[];
};

const props = defineProps<{
  tabs: UspTab[];
  boxed: boolean;
}>();

const value = ref(props.tabs[0]?.id ?? '');

const handleChange = (id: string) => {
  value.value = id;
};
</script>

<template>
  <phx-usp-tabs v-cloak :value="value" :boxed="boxed" @change="handleChange">
    <phx-usp-tab-panel v-for="tab in tabs" :id="tab.id" :key="tab.id" :label="tab.label" :media="tab.media">
      <h4 v-if="tab.title" class="mb-base">{{ tab.title }}</h4>

      <div class="list list--stacked list--divided list--xs md:list--base">
        <div v-for="(bullet, idx) in tab.bullets" :key="idx">
          <span>{{ bullet.text }}</span>
          <phx-tooltip
            v-if="bullet.tooltip"
            class="tooltip--inline"
            :trigger="{ class: 'btn--icon-only', icon: { id: 'info-12', size: '12' }, a11y: { label: bullet.tooltip } }"
            :text="bullet.tooltip"
          />
        </div>
      </div>
    </phx-usp-tab-panel>
  </phx-usp-tabs>
</template>
